import api from '@/services/api'

export interface AuthorizedUser {
  email: string
  is_active: boolean
  added_by: string
  created_at: string
  last_invited_at?: string | null
}

export interface AuthorizedUsersResponse {
  users: AuthorizedUser[]
  total: number
}

function emailPath(email: string): string {
  return encodeURIComponent(email)
}

export async function getAuthorizedUsers(): Promise<AuthorizedUsersResponse> {
  const response = await api.get<AuthorizedUsersResponse>('/authorized-users')
  return response.data
}

export async function addAuthorizedUser(email: string): Promise<AuthorizedUser> {
  const response = await api.post<AuthorizedUser>('/authorized-users', { email })
  return response.data
}

export async function updateAuthorizedUser(
  email: string,
  data: { is_active: boolean },
): Promise<AuthorizedUser> {
  const response = await api.patch<AuthorizedUser>(`/authorized-users/${emailPath(email)}`, data)
  return response.data
}

export async function removeAuthorizedUser(email: string): Promise<void> {
  await api.delete(`/authorized-users/${emailPath(email)}`)
}

export interface AuthorizedUserReinviteResponse {
  ok: boolean
  email: string
}

export async function reinviteAuthorizedUser(
  email: string,
): Promise<AuthorizedUserReinviteResponse> {
  const response = await api.post<AuthorizedUserReinviteResponse>(
    `/authorized-users/${emailPath(email)}/reinvite`,
  )
  return response.data
}
